import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({
    children,
    allowedRoles,
    requireApprovedPartner = false
}) {
    let user = null;

    try {
        user = JSON.parse(localStorage.getItem("user"));
    } catch {
        user = null;
    }

    // Check whether a user profile exists.
    if (!user || !user.role) {
        return <Navigate to="/login" replace />;
    }

    const role = String(user.role).trim().toUpperCase();
    const status = String(user.status || "").trim().toUpperCase();

    // Check allowed roles.
    if (
        allowedRoles &&
        !allowedRoles.map((r) => r.toUpperCase()).includes(role)
    ) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Block unapproved partners.
    if (
        role === "PARTNER" &&
        (requireApprovedPartner || true) &&
        status !== "APPROVED"
    ) {
        return (
            <Navigate
                to="/partner-verification"
                state={{ status: status || "PENDING" }}
                replace
            />
        );
    }

    return children;
}

export default ProtectedRoute;